/**
 *  企业云展系统
 * @document https://www.tapd.cn/38059561/markdown_wikis/?#1138059561001001001
 */
import qs from 'qs'
import axios from '@/api/apiClient'
// import { deepClone } from '@/utils/util'
const api = {
  CompanyList: '/api/company/cloudSystem/page',
  CompanyListV2: '/api/company/cloudSystem/page/v2',

  // 提醒企业更新模块内容
  remind: '/api/company/info/remind/data',
  // 点赞企业动态
  dynamicLike: '/api/company/column/like',
  // 员工明细数据
  subMemberDataPage: '/api/company/myinfo/subMemberData/page',
  // saveCardSystemInfo: `/api/memberCardCloudSystemLog/save`
  // 更新联系状态
  updateTalk: '/api/memberCardCloudSystemLog/updateTalk',
}
export default api
/**
 * 获取企业云展系统列表
 * @param {*} query.current 页码
 * @param {*} query.size 页容量
 */
export const getCompanyList = (query) => {
  return axios.$get(`${api.CompanyList}${query ? `?${qs.stringify(query)}` : ''}`)
}
export const getCompanyListV2 = (query) => {
  return axios.$get(`${api.CompanyListV2}${query ? `?${qs.stringify(query)}` : ''}`)
}

export const postRemind = (param) => {
  return axios.$post(`${api.remind}`, param)
}
export const postDynamicLike = (param) => {
  return axios.$post(`${api.dynamicLike}`, param)
}

export const getSubMemberDataPage = (query) => {
  return axios.$get(`${api.subMemberDataPage}${query ? `?${qs.stringify(query)}` : ''}`)
}

export const postUpdateTalk = (param) => {
  return axios.$post(`${api.updateTalk}`, param)
}
